import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { IDetails } from './model/IDetails';
import { TranslateService } from '@ngx-translate/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
@Component({
  selector: 'app-details-card',
  templateUrl: './details-card.component.html',
  styleUrls: ['./details-card.component.scss']
})
export class DetailsCardComponent implements OnInit {
  selectedRowIndex: number;
  @Input() selectedRowId: number = 0;
  @Output() goToDetails = new EventEmitter<string>();
  @Input() data: any;
  @Input() IsFTLShow: boolean = false;
  @Input() cardDetails: IDetails;
  @Input() isTableCardView: any;
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Input() isDiffTablePattern: any;
  @Input() noOfColumnToShowOnModile: any;
  isMobileView: any;
  @Output() GoToDetailsCard = new EventEmitter<any>();
  @Input() isActive: boolean = false;
  constructor(
    private translate: TranslateService,
    private mobileDetectionService: MobileDetectionService) { }
  ngOnInit(): void {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    !this.selectedRowId ? this.selectedRowIndex = 0 : null;
    setTimeout(() => {
      if (this.cardDetails.cartType == 'Role') {
        document.getElementById("card_body").classList.remove("h-100");
      }
    }, 1000);
  }

  gotToPage() {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  openEmailHyperLink(email: any) {
    const phoneLink = "mailto:+" + email;
    window.location.href = phoneLink;
  }

  onActionClick(row, event,) {
    this.onActionClickOutput.emit(event);
    return;
  }

  getCurruncyValue = (value: number): string => {
    if (value) {
      return (this.cardDetails.currencySymbol ? this.cardDetails.currencySymbol : "") + (value).toLocaleString('en-US');
    }
    return "";
  }
  onGoToClick(row: any) {
    this.goToDetails.emit(row);
    this.selectedRowIndex = null;
  }
  OnGoToDetailsCard(row, event,) {
    this.GoToDetailsCard.emit(event);
  }
}
